import jQuery from 'jquery';

import './libs/foundation';

import Animate from './components/animate';
import ArticleShare from './components/article-share';
import BackLink from './components/back-link';
import BackToTop from './components/back-to-top';
import DesktopMeganav from './components/desktop-meganav';
import Filters from './components/filters';
import Gallery from './components/gallery';
import HeroVideo from './components/hero-video';
import LogoScroller from './components/logo-scroller';
import MapComponent from './components/map';
import MobileNav from './components/mobile-nav';
import NewsCarousel from './components/news-carousel';
import ProjectFilter from './components/project-filter';
import ProjectListHover from './components/project-list-hover';
import ProjectsCarousel from './components/projects-carousel';
import QuoteSlider from './components/quote-slider';
import StatsCounter from './components/stats-counter';
import StickyHeader from './components/sticky-header';
import TeamCarousel from './components/team-carousel';
import Video from './components/video';

jQuery(($) => {
    new Animate();
    new ArticleShare();
    new BackLink();
    new BackToTop();
    new DesktopMeganav();
    new Filters();
    new Gallery();
    new HeroVideo();
    new LogoScroller();
    new MapComponent();
    new MobileNav();
    new NewsCarousel();
    new ProjectFilter();
    new ProjectListHover();
    new ProjectsCarousel();
    new QuoteSlider();
    new StatsCounter();
    new StickyHeader();
    new TeamCarousel();
    new Video();
});
